export default "/images/vendor/flag-icon-css/flags/1x1/sg.svg?8db1ed19f334e7b5ad26ae407f199798";